import { CREATE_SUNDRY_ITEM, CREATE_SUNDRY_TRANSACTION, CREATING_SUNDRY_ITEM, CREATING_SUNDRY_TRANSACTION, DELETE_SUNDRY_ITEM, DELETING_SUNDRY_ITEM, GET_SUNDRY_ACCOUNTS, GET_SUNDRY_ITEMS, GETTING_SUNDRY_ACCOUNTS, GETTING_SUNDRY_ITEMS, SUNDRIES_ERROR, UPDATE_SUNDRY_ITEM, UPDATING_SUNDRY_ITEM } from "../types"

const initialState = {
    sundryAccounts: [],
    loadingSundryAccounts: true,
    sundriesError: null,
    creatingSundryItem: false,
    createdSundryItem: null,
    fetchingSundryItems: true,
    sundryItems: [],
    updatingSundryItem: false,
    updatedSundryItem: null,
    deletingSundryItem: false,
    deletedSundryItem: null,
    creatingSundryTransaction: false,
    createdSundryTransaction: null,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case GETTING_SUNDRY_ACCOUNTS:
        return {
            ...state,
            loadingSundryAccounts :action.payload,
        }
        case GET_SUNDRY_ACCOUNTS:
        return{
            ...state,
            loadingSundryAccounts: false,
            sundriesError: null,
            sundryAccounts: action.payload,
        }
        case CREATING_SUNDRY_TRANSACTION:
        return {
            ...state,
            creatingSundryTransaction :action.payload,
        }
        case CREATE_SUNDRY_TRANSACTION:
        return{
            ...state,
            creatingSundryTransaction: false,
            sundriesError: null,
            createdSundryTransaction: action.payload,
        }
        case CREATING_SUNDRY_ITEM:
        return {
            ...state,
            creatingSundryItem: action.payload,
        }
        case CREATE_SUNDRY_ITEM:
        return{
            ...state,
            creatingSundryItem: false,
            sundriesError: null,
            createdSundryItem: action.payload,
        }
        case GETTING_SUNDRY_ITEMS:
        return {
            ...state,
            fetchingSundryItems: action.payload,
        }
        case GET_SUNDRY_ITEMS:
        return{
            ...state,
            fetchingSundryItems: false,
            sundriesError: null,
            sundryItems: action.payload,
        }
        case UPDATING_SUNDRY_ITEM:
        return {
            ...state,
            updatingSundryItem: action.payload,
        }
        case UPDATE_SUNDRY_ITEM:
        return{
            ...state,
            updatingSundryItem: false,
            sundriesError: null,
            updatedSundryItem: action.payload,
        }
        case DELETING_SUNDRY_ITEM:
        return {
            ...state,
            deletingSundryItem: action.payload,
            // fetchingMembers:false
        }
        case DELETE_SUNDRY_ITEM:
        return{
            ...state,
            deletingSundryItem: null,
            sundriesError: null,
            deletedSundryItem: action.payload,
        }
        case SUNDRIES_ERROR:
        return{
            ...state,
            loadingSundryItems: false,
            loadingSundryAccounts:false,
            deletingSundryItem: null,
            creatingSundryItem: false,
            updatingSundryItem: false,
            creatingSundryTransaction: false,
            sundriesError: action.payload 
        }
        default: return state
    }

}